import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface YouthTeaching {
  id: string;
  devotion_id: number;
  title: string;
  author: string;
  content: string;
  song_url?: string;
  created_at: string;
  updated_at: string;
}

export function useYouthTeaching(devotionId: number) {
  const [teaching, setTeaching] = useState<YouthTeaching | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Reset state when devotionId changes
    setTeaching(null);
    setError(null);
    
    async function fetchTeaching() {
      try {
        setIsLoading(true);

        const { data, error: fetchError } = await supabase
          .from('youth_teachings')
          .select('*')
          .eq('devotion_id', devotionId)
          .maybeSingle();

        if (fetchError) {
          throw fetchError;
        }

        console.log('Youth teaching data loaded:', {
          devotionId,
          title: data?.title,
          songUrl: data?.song_url
        });

        setTeaching(data);
      } catch (error: any) {
        console.error('Error fetching youth teaching:', error);
        setError(error.message || 'Failed to load youth teaching');
      } finally {
        setIsLoading(false);
      }
    }

    if (devotionId) {
      fetchTeaching();
    }
  }, [devotionId]);

  return { teaching, isLoading, error };
}